<table class="table table-bordered table-sm table-hover" id="en_service">
    <thead>
        <th (click)="sortby('nom_installation')" scope="col">Nom installation</th>
        <th (click)="sortby('societe_proprietaire_raison_sociale')" scope="col">Société</th>
        <th (click)="sortby('adresse_code_postal')" scope="col">Code Postal</th>
        <th (click)="sortby('adresse_ville')" scope="col">Adresse</th>
        <th (click)="sortby('adresse_pays')" scope="col">Pays</th>
        <th (click)="sortby('date_desinstallation')" scope="col">Date de désinstallation</th>
    </thead>
    <tbody>
        <ng-container *ngIf="installations">
        <ng-container *ngFor="let installation of installations.desinstallees">
            <tr (click)="onClickMachine(installation.id_installation)">
                <td>{{installation.nom_installation}}</td>
                <td>{{installation.societe_proprietaire_raison_sociale}}</td>
                <td>{{installation.adresse_code_postal}}</td>
                <td>{{installation.adresse_ville}}</td>
                <td>{{installation.adresse_pays}}</td>
                <td>{{installation.date_desinstallation}}</td>
            </tr>
        </ng-container>
    </ng-container>
    </tbody>
</table>